<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>Audit Logs</v-toolbar-title>
    </v-toolbar>

    <ag-grid-vue
  			class="ag-theme-alpine"
  			domLayout="autoHeight"
  			:columnDefs="columnDefs"
  			:defaultColDef="defaultColDef"
  			:rowData="logs"
  			:gridOptions="gridOptions"
        :pagination="true"
        :paginationPageSize="15"
        @first-data-rendered="onFirstDataRendered"
  		></ag-grid-vue>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "AuditLogs",
  data: () => ({
    loading: true,
    keyword: "",
    columnDefs: null,
    gridOptions: null,
    logs: [],
    pageNo: 0,
    pageSize: 200,
    frameworkComponents: null
  }),
  components: { AgGridVue },
  beforeMount () {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "Transaction Time/Date",
        field: "transactionTimeDate",
        sortable: true,
        filter: true
      },
      {
        headerName: "Comment",
        field: "comment",
        filter: true
      },
      {
        headerName: "Customer Number",
        field: "custNo",
        sortable: true,
        filter: true
      },
      {
        headerName: "Transaction Type",
        field: "transactionType",
        filter: true
      },
      {
        headerName: "Success",
        field: "success",
        filter: true
      },
      {
        headerName: "Error",
        field: "error",
        filter: true
      }
    ];

    vm.defaultColDef = {
      resizable: true,
      autoHeight: true
    };
  },
  mounted () {
    let vm = this;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
  methods: {
    ...mapActions("reminders", ["loadAuditLog"]),
    loadData (pagination) {
      if (!pagination) pagination = { pageNo: 0, pageSize: 200 };
      this.loadAuditLog({
        pageNo: pagination.page,
        pageSize: 200 //pagination.itemsPerPage
      }).then(data => {
        this.logs = data;
        this.loading = false;
      });
    },
    onFirstDataRendered (grid) {
      grid.api.sizeColumnsToFit();
    }
  },
  created () {
    setTimeout(() => {
      this.loadData();
    }, 100);
  }
};
</script>
